<template>
  <div>
    <Clouds quantity="4" />
    <div class="thanks">
      <div class="container">
        <h1>Thank you!</h1>
        <p>Alright skipper, you joined the crew!</p>
        <p>
          You should receive a confirmation dispatch.
          <br />Check your inbox, sometimes it may end up
          <br />in a promotion panel or even in spam.
          Ahoy!
        </p>
        <div class="share">
          <p>Share this project on social media!</p>
          <ShareNetwork
            v-for="(sm, index) in ['facebook', 'twitter', 'reddit', 'whatsapp',  'telegram']"
            :key="index"
            :network="sm"
            url="https://petsnpirates.com"
            title="Pets 'n' Pirates, a new amazing card game!"
            hashtags="petsnpirates,cardgame"
            @open="track('share', sm)"
          >
            <font-awesome-icon :icon="['fab', sm]" />
            &nbsp;{{sm}}
          </ShareNetwork>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import Clouds from "@/components/Clouds.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faReddit } from "@fortawesome/free-brands-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faTelegram } from "@fortawesome/free-brands-svg-icons";

library.add( faFacebook, faTwitter, faReddit, faWhatsapp, faTelegram);

export default {
  name: "Thanks",
  components: {
    Footer,
    Clouds,
  },
  created: function(){
    this.track('Subscribe', 'Newsletter')
  },
  methods: {
    track(action, category) {
      this.$gtag.event(action),
        {
          eventCategory: category,
        };
      window.fbq("trackCustom", action);
    },
  },
};
</script>

<style lang="scss">
.thanks {
  position: relative;
  min-height: 100%;
  padding-top: 10rem;
  text-align: center;
  z-index: 100;
  .share {
    margin-top: 2rem;
    a {
      color: white;
      margin: 1rem 0.5rem;
      padding: 0.5rem;
      display: inline-block;
      cursor: pointer;
      &.share-network-facebook {
        background-color: #3b5998;
      }
      &.share-network-twitter {
        background-color: #1da1f2;
      }
      &.share-network-reddit {
        background-color: #ff4500;
      }
      &.share-network-whatsapp {
        background-color: #25d366;
      }
      &.share-network-telegram {
        background-color: #0088cc;
      }
    }
  }
}
</style>